"use client";
import { useCallback, useState } from "react";

import { StaticImageData } from "next/image";

const thumbnailNumPerGroup = 4;

export const useProductImages = ({ imageSrcs }: { imageSrcs: (StaticImageData | string)[] }) => {
  // 4枚以下の場合は前後のボタンを無効にする
  const isCursorDisabled = imageSrcs.length <= thumbnailNumPerGroup;
  // サムネイル画像グループの最大インデックス
  const maxGroupIndex = Math.floor((imageSrcs.length - 1) / thumbnailNumPerGroup);
  // メインで表示されている画像のインデックス
  const [currentSelectedImageIndex, setCurrentSelectedImageIndex] = useState(0);
  // 現在のサムネ画像グループのインデックス
  const [currentGroupIndex, setCurrentGroupIndex] = useState(0);

  const changeMainImage = useCallback((index: number) => {
    setCurrentSelectedImageIndex(index);
  }, []);

  const nextThumbnailGroup = useCallback(() => {
    setCurrentGroupIndex((prev) => (prev >= maxGroupIndex ? 0 : prev + 1));
  }, [maxGroupIndex]);

  const prevThumbnailGroup = useCallback(() => {
    setCurrentGroupIndex((prev) => (prev === 0 ? maxGroupIndex : prev - 1));
  }, [maxGroupIndex]);

  return {
    currentSelectedImage: imageSrcs[currentSelectedImageIndex],
    startIndex: currentGroupIndex * thumbnailNumPerGroup,
    endIndex: currentGroupIndex * thumbnailNumPerGroup + thumbnailNumPerGroup,
    isCursorDisabled,
    changeMainImage,
    nextThumbnailGroup,
    prevThumbnailGroup,
  };
};
